import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import type { SanityReference } from "next-sanity";
import type { CSSProperties } from "react";
import TrackingPixel from "src/components/ads/TrackingPixel";
import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import { getOrgSize } from "src/components/images/imageFunctions";
import styles from "./ProgramControlsSponsor.module.css";
// duplicate import cleanup

//#region [Props]
type ProgramControlsSponsorProps = {
  isSticky?: boolean;
  className?: string;
  sponsorClickUrl?: string | null;
  sponsorTopImageDesktop?: SanityReference[] | null;
  sponsorTopImageMobile?: SanityReference[] | null;
};
//#endregion

//const clickDestination = "https://www.coca-cola.com/no/no/offerings/fanta-appelsin?utm_source=Filmweb&utm_medium=Sponsorship&utm_campaign=Filmweb_Fanta_Sponsorship";

/**
 * NOTE:
 * sponsorTopImage[0] benyttes når programmenyen ikke er sticky
 * sponsorTopImage[1] benyttes når programmenyen er sticky
 *
 */

//#region [Component]
export default function ProgramControlsSponsor(t0) {
  const $ = _c(28);
  const {
    isSticky,
    className,
    sponsorClickUrl,
    sponsorTopImageDesktop,
    sponsorTopImageMobile
  } = t0;
  if ((!sponsorTopImageDesktop || sponsorTopImageDesktop.length === 0) && (!sponsorTopImageMobile || sponsorTopImageMobile.length === 0)) {
    return null;
  }
  let t1;
  if ($[0] !== sponsorTopImageDesktop) {
    t1 = sponsorTopImageDesktop?.map(_temp);
    $[0] = sponsorTopImageDesktop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const orgSizesDesktop = t1;
  let t2;
  if ($[2] !== sponsorTopImageMobile) {
    t2 = sponsorTopImageMobile?.map(_temp2);
    $[2] = sponsorTopImageMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const orgSizesMobile = t2;
  let cssStyle;
  let hasDesktopSticky;
  let hasMobileSticky;
  if ($[4] !== orgSizesDesktop || $[5] !== orgSizesMobile) {
    cssStyle = {};
    hasDesktopSticky = (orgSizesDesktop?.length ?? 0) > 1;
    hasMobileSticky = (orgSizesMobile?.length ?? 0) > 1;
    if ((orgSizesDesktop?.length ?? 0) > 0) {
      cssStyle["--aspect-ratio-d"] = `${orgSizesDesktop[0].width} / ${orgSizesDesktop[0].height}`;
      cssStyle["--sponsor-width-d"] = `${orgSizesDesktop[0].width}px`;
    }
    if ((orgSizesMobile?.length ?? 0) > 0) {
      cssStyle["--aspect-ratio-m"] = `${orgSizesMobile[0].width} / ${orgSizesMobile[0].height}`;
    }
    if (hasDesktopSticky) {
      cssStyle["--aspect-ratio-d-sticky"] = `${orgSizesDesktop[1].width} / ${orgSizesDesktop[1].height}`;
    }
    if (hasMobileSticky) {
      cssStyle["--aspect-ratio-m-sticky"] = `${orgSizesMobile[1].width} / ${orgSizesMobile[1].height}`;
    }
    $[4] = orgSizesDesktop;
    $[5] = orgSizesMobile;
    $[6] = cssStyle;
    $[7] = hasDesktopSticky;
    $[8] = hasMobileSticky;
  } else {
    cssStyle = $[6];
    hasDesktopSticky = $[7];
    hasMobileSticky = $[8];
  }
  const WrapperTag = !!sponsorClickUrl ? "a" : "div";
  const t3 = !!sponsorClickUrl ? sponsorClickUrl : undefined;
  const t4 = cssStyle as CSSProperties;
  const t5 = !!isSticky;
  let t6;
  if ($[9] !== className || $[10] !== t5) {
    t6 = classNames(styles.SSponsor, className, {
      [styles.isSticky]: t5
    });
    $[9] = className;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== hasMobileSticky || $[13] !== isSticky || $[14] !== sponsorTopImageMobile) {
    t7 = !!sponsorTopImageMobile && <>{(hasMobileSticky && !isSticky || !hasMobileSticky) && <CmsImageForAssetRef className={styles.SCmsImageForAssetRefMobile} assetRef={sponsorTopImageMobile[0]._ref} alt="Sponsor" />}{hasMobileSticky && isSticky && <CmsImageForAssetRef className={styles.SCmsImageForAssetRefMobile} assetRef={sponsorTopImageMobile[1]._ref} alt="Sponsor" />}</>;
    $[12] = hasMobileSticky;
    $[13] = isSticky;
    $[14] = sponsorTopImageMobile;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== hasDesktopSticky || $[17] !== isSticky || $[18] !== sponsorTopImageDesktop) {
    t8 = !!sponsorTopImageDesktop && <>{(hasDesktopSticky && !isSticky || !hasDesktopSticky) && <CmsImageForAssetRef className={styles.SCmsImageForAssetRefDesktop} assetRef={sponsorTopImageDesktop[0]._ref} alt="Sponsor" />}{hasDesktopSticky && isSticky && <CmsImageForAssetRef className={styles.SCmsImageForAssetRefDesktop} assetRef={sponsorTopImageDesktop[1]._ref} alt="Sponsor" />}</>;
    $[16] = hasDesktopSticky;
    $[17] = isSticky;
    $[18] = sponsorTopImageDesktop;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TrackingPixel className={styles.STrackingPixel} targetId="SponsorTrackingPixel" />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== WrapperTag || $[22] !== t3 || $[23] !== t4 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t10 = <WrapperTag href={t3} target="_blank" style={t4} className={t6}>{t7}{t8}{t9}</WrapperTag>;
    $[21] = WrapperTag;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}
//#endregion

//#region [Styles]
// Moved to ProgramControlsSponsor.module.css
//#endregion
function _temp2(ref_0) {
  return getOrgSize(ref_0._ref);
}
function _temp(ref) {
  return getOrgSize(ref._ref);
}